import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export default makeStyles((theme: Theme) => ({
  Wrapper: {
    height: "auto",
    width: "100%",
    position: "relative",
    '& .MuiTypography-h6': {
      fontSize: '17px',
    },
  },
  ToMain: {
    fontSize: "20px",
    cursor: "pointer"
  },
  StatusesList: {
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    gap: "16px",
    height: "50px",
    maxWidth: "calc(100% - 80px)",
    overflowX: "auto",
    overflowY: "hidden",
    whiteSpace: "nowrap",
    scrollbarWidth: "thin",
    '&::-webkit-scrollbar': { height: 4 },
    '&::-webkit-scrollbar-thumb': { background: '#f0c99a', borderRadius: 4 },
    '& p': {
      fontSize: "15px",
    },
    '& span': {
      color: "orange",
      fontSize: "15px",
    }
  },
  FilterRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "16px",
    flexWrap: "wrap",
    padding: "0 10px",
  },
  ReportSection: {
    margin: "0 10px 16px",
    padding: "16px",
    border: "1px solid #fc7f03",
    borderRadius: "8px",
  },
  ReportStats: {
    display: "flex",
    gap: "24px",
    flexWrap: "wrap",
    marginTop: "12px",
  },
  StatCard: {
    padding: "12px 20px",
    borderRadius: "8px",
    backgroundColor: "#ede9e4",
    textAlign: "center" as const,
  },
}));
